<i18n
  src="@/locales/views/customer/quality_control/destination/show_inspect.yml"
  lang="yaml"
></i18n>
<i18n src="@/locales/models/quality_inspect.yml" lang="yaml"></i18n>
<template>
  <go-back-link
    :text="$t('labels.go_back_link')"
    name="customer_quality_control_destination_list_inspects_path"
    :params="{
      customer_id: customer_id,
      container_id: container_id,
      agro_exporter_id: agro_exporter_id,
      exporter_process_quality_template_id: exporter_process_quality_template_id
    }"
  ></go-back-link>
  <bread-crumbs
    :labels="[
      module_name,
      agro_exporter.name,
      container.container_code,
      quality_template.name
    ]"
  ></bread-crumbs>

  <div v-if="load_data_general">
    <container-info :container="container" :show_info="true"></container-info>
    <quality-inspect-info
      :quality_inspect="quality_inspect"
      :container_id="container_id"
      :exporter_process_quality_template_id="
        exporter_process_quality_template_id
      "
    ></quality-inspect-info>

    <tabs-container v-if="option_tabs.length > 0" v-model="option_tabs" />

    <div
      v-for="(option_tab, index) in option_tabs"
      :key="index"
      class="mt-6"
      v-show="option_tab.current"
    >
      <quality-group-details
        v-if="option_tab.current"
        :use_samplings="quality_template?.use_samplings"
        :quality_attributes="quality_attributes"
        :quality_samplings="quality_samplings"
        :quality_inspect="quality_inspect"
        :quality_group="current_group"
        :quality_template="quality_template"
      />
    </div>
  </div>
  <loading-message v-else />
</template>

<script>
import GoBackLink from "@/components/views/layout/GoBackLink.vue";
import Requester from "@/views/customer/requesters/quality_control/container/show_inspect.js";
import QualityInspectInfo from "@/components/views/customer/quality_control/destination/QualityInspectInfo.vue";
import QualityGroupDetails from "@/components/views/customer/quality_control/destination/show_inspect/QualityGroupDetails.vue";
import ContainerInfo from "@/components/views/customer/quality_control/destination/ContainerInfo.vue";
import BreadCrumbs from "@/components/views/layout/BreadCrumbs.vue";
export default {
  name: "CustomerProductionContainerQualityShowExportQualityInspect",
  components: {
    GoBackLink,
    ContainerInfo,
    QualityGroupDetails,
    QualityInspectInfo,
    BreadCrumbs
  },
  data() {
    return {
      load_data_general: false,
      quality_inspect: {},
      quality_template: {},
      agro_exporter: {},
      container: {},
      option_tabs: [],
      quality_groups: [],
      quality_sampling_details: []
    };
  },
  props: {
    customer_id: { required: true },
    container_id: {
      required: true
    },
    quality_inspect_id: {
      required: true
    },
    exporter_process_quality_template_id: {
      required: true
    },
    agro_exporter_id: {
      required: true
    },
  },
  created() {
    this.checkIfAuthenticated().then(() =>
      this.checkIfAuthorized({
        role: this.$route.meta.role,
        permission: this.$route.meta.permission,
        entity: {
          customer_id: this.customer_id
        }
      }).then(() => {
        this.fetchData();
      })
    );
  },
  computed: {
    current_group: function () {
      return this.quality_groups.find(
        quality_group => quality_group.id == this.find_current_tab?.id
      );
    },
    find_current_tab() {
      return this.option_tabs.find(option_tab => option_tab.current);
    },
    quality_attributes: function () {
      return this.quality_groups
        .find(quality_group => quality_group.id == this.find_current_tab?.id)
        .quality_attributes.sort((a, b) => a.position - b.position);
    },
    quality_samplings: function () {
      let quality_samplings = [];
      for (
        let sampling = 1;
        sampling <= this.quality_inspect.samplings;
        sampling++
      ) {
        let quality_sampling = this.quality_inspect.quality_samplings.find(
          quality_sampling => quality_sampling.sampling == sampling
        );
        quality_samplings.push(quality_sampling || {});
      }
      return quality_samplings;
    },
    show_legend: function () {
      return (
        this.quality_attributes.map(qa => qa.abbreviation).filter(abbr => abbr)
          .length > 0
      );
    }
  },
  methods: {
    fetchData: async function () {
      await this.fetchAgroExporter();
      await this.fetchContainer();
      await this.fetchInspect().then(() => {
        this.fetchTemplate();
        this.fetchGroups();
      });
    },
    fetchAgroExporter: async function () {
      let response = await Requester.fetchAgroExporter({
        customer_id: this.customer_id,
        agro_exporter_id: this.agro_exporter_id
      });
      this.agro_exporter = response.data;
    },
    switchTab: function (tabIdx) {
      for (let i = 0; i < this.option_tabs.length; i++) {
        this.option_tabs[i].current = false;
      }
      this.option_tabs[tabIdx].current = true;
    },
    fetchContainer: async function () {
      let response = await Requester.fetchContainer({
        customer_id: this.customer_id,
        agro_exporter_id: this.agro_exporter_id,
        container_id: this.container_id
      });
      this.container = response.data;
    },
    fetchInspect: async function () {
      let response = await Requester.fetchInspect({
        customer_id: this.customer_id,
        agro_exporter_id: this.agro_exporter_id,
        container_id: this.container_id,
        exporter_process_quality_template_id:
          this.exporter_process_quality_template_id,
        quality_inspect_id: this.quality_inspect_id
      });
      this.quality_inspect = response.data;
    },
    fetchTemplate: async function () {
      let response = await Requester.fetchTemplate({
        customer_id: this.customer_id,
        agro_exporter_id: this.agro_exporter_id,
        container_id: this.container_id,
        exporter_process_quality_template_id:
          this.exporter_process_quality_template_id
      });
      this.quality_template = response.data;
    },
    listExportQualityGroups: function () {
      this.quality_groups = this.quality_inspect.quality_samplings
        .map(quality_sampling => quality_sampling.quality_sampling_groups)
        .flat()
        .map(quality_sampling_group => quality_sampling_group.quality_group)
        .reduce(
          (quality_groups, quality_group) =>
            quality_groups.find(item => item.id === quality_group.id)
              ? quality_groups
              : [...quality_groups, quality_group],
          []
        );
    },
    listExporterQualityAttributes: async function (export_quality_group_id) {
      let response = await Requester.fetchExporterQualityAttributes(
        export_quality_group_id
      );
      this.quality_attributes = response.data.sort(
        (a, b) => a.position - b.position
      );
    },
    findExportQualitySamplingDetailValue: function (quality_attribute_id) {
      let quality_sampling_detail = this.quality_sampling_details.find(
        quality_sampling_detail =>
          quality_sampling_detail.quality_attribute_id === quality_attribute_id
      );

      return (
        quality_sampling_detail?.value ||
        quality_sampling_detail.value_float ||
        quality_sampling_detail.value_bool
      );
    },
    fetchGroups: async function () {
      let response = await Requester.fetchGroups({
        customer_id: this.customer_id,
        agro_exporter_id: this.agro_exporter_id,
        container_id: this.container_id,
        exporter_process_quality_template_id:
          this.exporter_process_quality_template_id
      });
      this.quality_groups = response.data;
      this.option_tabs = this.quality_groups.map(eq_group => {
        return {
          id: eq_group.id,
          name: eq_group.name,
          icon: "fas fa-eye",
          current: this.quality_groups[0].id === eq_group.id
        };
      });
      this.load_data_general = true
    },
    cellValue: function (eq_sampling, eq_attribute_id) {
      if (Object.keys(eq_sampling).length === 0) return;

      return eq_sampling.quality_sampling_groups
        .find(
          sampling_group =>
            sampling_group.quality_group_id == this.find_current_tab.id
        )
        ?.quality_sampling_details?.find(
          sampling_detail =>
            sampling_detail.quality_attribute_id === eq_attribute_id
        )?.value;
    }
  }
};
</script>
